











import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RenderContentModel, RenderTemplateModel, Button } from "@/services/render/types";
import { renderTemplate, getSolution } from "@/services/render/renderService";
import ContentRenderComponent from "@/components/render/ContentRender.vue";
import { Action } from "vuex-class";
import i18n from "@/i18n";

@Component({
    components: {
        ContentRenderComponent
    }
})
export default class SolutionRender extends Vue {
    @Prop() solutionId!: string;
    @Prop() solutionTimezoneId!: string;
    @Prop() dateTimeProp!: string;
    @Prop() styles!: string;
    @Prop({ default: "" }) highlightId!: string;
    @Action("render/setCurrentSolutionTimezoneId") setCurrentSolutionTimezoneId!: any;

    // local state
    showMsg = false;
    msg = i18n.t("solution.templateNotAssigned").toString();
    templateId: string = "";
    playerSolutionId: string = "";
    contentRenderModel = {
        height: 0,
        width: 0,
        renderChannels: [] as Array<RenderContentModel>,
        buttons: [] as Array<Button>
    } as RenderTemplateModel;

    contentRenderReload = 0;

    @Watch("dateTimeProp") update() {
        this.getSolution();
    }

    @Watch("solutionId") updateRender() {
        this.getSolution();
    }

    @Watch("solutionTimezoneId") updateTimezone() {
        this.setCurrentSolutionTimezoneId(this.solutionTimezoneId);
    }

    // lifecycle hooks
    mounted() {
        this.getSolution();
        this.setCurrentSolutionTimezoneId(this.solutionTimezoneId);
    }

    destroyed() {
        this.setCurrentSolutionTimezoneId(null);
    }

    // computed
    get model(): RenderTemplateModel {
        return this.contentRenderModel;
    }

    dateTime() {
        return this.dateTimeProp ? this.dateTimeProp : this.getDateTimeString();
    }

    // methods
    getSolution() {
        getSolution(this.solutionId).then(response => {
            if (!response.templateId) {
                this.showMsg = true;
                return;
            };
            this.templateId = response.templateId;
            this.initRenderTemplate();
        });
    }

    initRenderTemplate() {
        this.showMsg = false;
        renderTemplate(this.templateId, this.dateTime()).then(
            response => {
                this.contentRenderReload += 1;
                this.contentRenderModel = response;
            }
        );
    }

    getDateTimeString() {
        return `${new Date().toDateString()} ${new Date().getHours()}:${new Date().getMinutes()}`;
    }
}
